/** Settings navigation section shared by the accounts UI features (CF-0026 nav registry). */
import SettingsIcon from "@mui/icons-material/Settings";

import { registerNavSection } from "./shell/navigation";

registerNavSection({
  key: "settings",
  spoke: "accounts",
  title: "Settings",
  icon: SettingsIcon,
  order: 900,
  entries: [
    { label: "My profile", to: "/app/settings/profile" },
    { label: "Security", to: "/app/settings/security" },
    { label: "Organization", to: "/app/settings/organization", permission: "accounts.organization.view" },
    { label: "Sites", to: "/app/settings/sites", permission: "accounts.site.view" },
    { label: "Members", to: "/app/settings/members", permission: "accounts.membership.view" },
    { label: "Roles", to: "/app/settings/roles", permission: "accounts.role.view" },
    { label: "API keys", to: "/app/settings/api-keys" },
    { label: "Billing", to: "/app/settings/billing", permission: "billing.subscription.view" },
    { label: "Single sign-on", to: "/app/settings/sso", permission: "accounts.sso.view" },
    { label: "Audit log", to: "/app/settings/audit", permission: "audit.log.view" },
    { label: "Background jobs", to: "/app/ops/jobs" },
    { label: "Dead letters", to: "/app/ops/dead-letters", permission: "hub.maintenance.manage" },
    { label: "Maintenance", to: "/app/ops/maintenance", permission: "hub.maintenance.manage" },
  ],
});
